var map = {
	"./img_1.jpg": 21342,
	"./img_10.jpg": 42875,
	"./img_2.jpg": 95247,
	"./img_3.jpg": 57989,
	"./img_4.jpg": 62873,
	"./img_5.jpg": 18092,
	"./img_6.jpg": 60899,
	"./img_7.jpg": 14608,
	"./img_8.jpg": 51569,
	"./img_9.jpg": 19007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94972;